import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';
import { rutaDetalleTramite } from '../../utils/rutasTramite';
import ModalCambioTipoTramite from './ModalCambioTipoTramite';
import ModalEliminarDefinitivo from './ModalEliminarDefinitivo';

// Zona de acciones irreversibles de la ficha del trámite. Va al final, separada y en rojo, para
// que no se confunda con la operatoria normal.
//
// Quién ve qué:
//   - Cambiar el tipo: ADMIN y PROGRAMADOR, y solo en los tipos convertibles (RTI y ART quedan afuera).
//   - Eliminar definitivamente: ADMIN y PROGRAMADOR, en cualquier tipo.
// El backend vuelve a chequear las dos cosas; esto es solo para no mostrar botones que van a fallar.

const TIPOS_NO_CONVERTIBLES = ['RTI', 'ART'];

function PanelAccionesAvanzadasTramite({ idTramite, tipoTramite }) {
    const { user } = useAuth();
    const navigate = useNavigate();
    const [modalTipo, setModalTipo] = useState(false);
    const [modalEliminar, setModalEliminar] = useState(false);

    // Las dos acciones sacan al usuario de esta ficha, asi que la navegacion se resuelve aca y no
    // en cada una de las once vistas que montan este panel:
    //   - al cambiar el tipo, el tramite pasa a vivir en otro modulo (esta ruta ya no lo sirve);
    //   - al eliminarlo, la ficha deja de existir.
    const irAlNuevoTipo = (tipoNuevo) => {
        navigate(rutaDetalleTramite({ idTramite, tipoTramite: tipoNuevo }), { replace: true });
    };
    const volverAlListado = () => navigate('/tramites', { replace: true });

    const rol = user?.rol;
    const esGestion = rol === 'ADMIN' || rol === 'PROGRAMADOR';
    const puedeEliminar = esGestion;
    const puedeCambiarTipo = esGestion
        && !!tipoTramite
        && !TIPOS_NO_CONVERTIBLES.includes(String(tipoTramite).toUpperCase());

    if (!idTramite) return null;
    if (!puedeEliminar && !puedeCambiarTipo) return null;

    return (
        <div className="card border-0 rounded-4 p-4 mb-3" style={{ background: '#fff5f5', border: '1px solid #fecaca' }}>
            <h6 className="fw-bold text-danger mb-1">
                <i className="bi bi-shield-exclamation me-2" />
                Acciones avanzadas
            </h6>
            <p className="text-muted mb-3" style={{ fontSize: '0.85rem' }}>
                Operaciones irreversibles. Quedan registradas en el log de auditoría con tu usuario.
            </p>

            <div className="d-flex flex-wrap gap-2">
                {puedeCambiarTipo && (
                    <button
                        type="button"
                        className="btn btn-outline-primary btn-sm rounded-pill px-3"
                        onClick={() => setModalTipo(true)}
                    >
                        <i className="bi bi-arrow-left-right me-2" />
                        Cambiar tipo de trámite
                    </button>
                )}
                {puedeEliminar && (
                    <button
                        type="button"
                        className="btn btn-outline-danger btn-sm rounded-pill px-3"
                        onClick={() => setModalEliminar(true)}
                    >
                        <i className="bi bi-trash3 me-2" />
                        Eliminar definitivamente
                    </button>
                )}
            </div>

            <ModalCambioTipoTramite
                open={modalTipo}
                onClose={() => setModalTipo(false)}
                idTramite={idTramite}
                tipoActual={tipoTramite}
                onCambiado={irAlNuevoTipo}
            />

            <ModalEliminarDefinitivo
                open={modalEliminar}
                onClose={() => setModalEliminar(false)}
                tipo="TRAMITE"
                identificador={idTramite}
                onEliminado={volverAlListado}
            />
        </div>
    );
}

export default PanelAccionesAvanzadasTramite;
